// extracted by mini-css-extract-plugin
export default {"rootMobile":"BaseFareAttributes-module__rootMobile___HvdEv","attributeBadge":"BaseFareAttributes-module__attributeBadge___prvZ0"};